import React, { memo } from 'react';

import { Route, Routes } from 'react-router-dom';

import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { useInjector } from 'utils/inject';

import { DataGroupComponent } from './Components/DataGroupComponent';
import { CreateDataGroup } from './Components/DataGroupWizard/CreateDataGroup';
import { EditDataGroup } from './Components/DataGroupWizard/EditDataGroup';
import { dataGroupsSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const DataGroups = memo(() => {
  useInjector(sliceKey, reducer, dataGroupsSaga);

  return (
    <ActiveResourceProvider>
      <Routes>
        <Route path="add" element={<CreateDataGroup />} />
        <Route path="edit/:id" element={<EditDataGroup />} />
        <Route
          index
          element={<DataGroupComponent basePath="/jit/data/group" />}
        />
      </Routes>
    </ActiveResourceProvider>
  );
});
